import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import API from '../../tools/API';
import SingleVoatingCathegoryTile from '../../components/SingleVoatingCathegory/SingleVoatingCathegoryTile';
import Modal from '../../components/Modal/Modal';
import AddCathegoryModal from '../../components/Modal/AddCathegoryModal';
import style from './App.module.scss';
import { SingleChannel, SingleSelectedChannel } from '../../tools/interfaces'
import EditCategoryModal from '../../components/Modal/EditCategoryModal';

interface Response {
    id: number,
    name: string,
    pollCount: number,
    votingTo: string
}

interface ModalData {
    id: number | undefined,
    name: string | undefined,
    generate: boolean | undefined
}

const App = () => {

    const [cathegories, setCathegories] = useState<Response[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [stationsIdList, setStationIdList] = useState([]);
    const [selectedStation, setSelectedStation] = useState<SingleSelectedChannel | null>(null);
    const [modalEdit, setModalEdit] = useState<ModalData | boolean>(false);

    useEffect(() => {
        API.getListOffRadioIds().then(res => {
            const stationArr = res?.data.data;
            const mappedStationArr = stationArr.map((x: SingleChannel) => {
                return (
                    {
                        value: x.id,
                        label: x.name
                    }
                )
            })
            setSelectedStation(mappedStationArr[0]);
            setStationIdList(mappedStationArr)
        })
    }, [])


    useEffect(() => {
        if (!showModal && selectedStation && !modalEdit) {
            API.getListOfCathegory(selectedStation.value.toString()).then(res => setCathegories(res?.data.data));
        }
    }, [showModal, selectedStation, modalEdit])

    const customStyles = {
        indicatorsContainer: () => ({
            backgroundColor: '#e10626',
            borderRadius: '50%',
            marginLeft: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }),
        control: () => ({
            display: 'flex',
            padding: '15px 25px 15px 40px',
            backgroundColor: 'white',
            boxShadow: '0 18px 15px rgba(0, 0, 0, 0.16)',
            borderRadius: '25px',
            fontSize: '20px',
            fontWeight: '500'
        }),
        dropdownIndicator: () => ({
            color: 'white',
            padding: '5px 9px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    }


    return (
        <div className={style.App}>
            <div className={style.App__topRow}>
                <button
                    className={style.App__button}
                    onClick={(e) => {
                        e.preventDefault();
                        setShowModal(true);
                    }
                    }><div className={style.addIcon}></div>Dodaj kategorię</button>
            </div>
            <div className={style.App__row}>
                <Select
                    value={selectedStation}
                    onChange={(e) => {
                        setSelectedStation(e)
                    }}
                    options={stationsIdList}
                    placeholder={"Wybierz stację"}
                    styles={customStyles}
                />
            </div>
            <div className={style.App__row}>
                {cathegories && (
                    cathegories.map((x, index) => {
                        return <SingleVoatingCathegoryTile
                            id={x.id}
                            name={x.name}
                            key={index}
                            openModal={setModalEdit}
                            pollCount={x.pollCount}
                            votingTo={x.votingTo}
                        />
                    })
                )}
            </div>
            {showModal && (
                <Modal openModal={setShowModal}>
                    <AddCathegoryModal openModal={setShowModal} stationList={stationsIdList} />
                </Modal>
            )
            }
            {modalEdit && (
                <Modal openModal={setModalEdit}>
                    <EditCategoryModal
                        openModal={setModalEdit}
                        editData={modalEdit}
                    />
                </Modal>
            )

            }
        </div>
    );
}

export default App;
